import { Injectable, signal, inject } from '@angular/core';
import { ClaimViewResponse } from '../../models/api/view/claim-view/claim-view-response';
import { Api } from '../api/api.service';
import { Session } from '../session/session.service';
import { BaseService } from '../base.service';
import { ClaimViewColumnService } from './claim-view-column.service';

@Injectable({
  providedIn: 'root',
})
export class SpecificClaimsListService extends BaseService {
  private api = inject(Api);
  private session = inject(Session);
  private claimViewColumnService = inject(ClaimViewColumnService);

  private _claims = signal<ClaimViewResponse | null>(null);
  claims = this._claims.asReadonly();

  constructor() {
    super();
    this.dispose.subs = this.session.cacheCleared.subscribe(() => {
      this._claims.set(null);
    });

    this.dispose.subs =
      this.claimViewColumnService.columnConfigRefreshed$.subscribe(() =>
        this.forceLoad(),
      );
  }

  async load(): Promise<void> {
    if (this._claims() === null) {
      await this.forceLoad();
    }
  }

  /** Force reload so table refreshes with new column config and data (e.g. after saving columns). */
  async forceLoad(): Promise<void> {
    const [specificClaims, columns] = await Promise.all([
      this.api.specificClaimsList.get(),
      this.claimViewColumnService.load(),
    ]);
    specificClaims.columns = columns.columns;
    specificClaims.unselectedColumns = columns.unselectedColumns;
    this._claims.set(specificClaims);
  }
}
